<section class="dts bsx" *ngIf="post as p"
         (pointerenter)="hold( true )" (pointerleave)="hold( false )" (focusin)="hold( true )" (focusout)="hold( false )">
  <div class="dts-copy">
    <!-- the shown post (owner 2026-10-11) -->
    <span class="dts-eyebrow"><img class="dts-eyebrow-logo" src="./assets/product-lines/tools/blog.svg" alt="" width="18" height="18"/>{{ eyebrow }}</span>
    <div class="bsx-body">
      <ng-container *ngFor="let k of [ p.key ]">
        <span class="bsx-cat bsx-fade" *ngIf="showCategory">{{ p.categoryLabel }}</span>
        <h2 class="dts-title bsx-title bsx-fade"><img class="dts-title-icon bsx-icon" *ngIf="p.icon" [src]="p.icon" alt="" width="48" height="48"/>{{ p.title }}</h2>
        <p class="dts-text bsx-summary bsx-fade">{{ story }}</p>
      </ng-container>
    </div>
    <ul class="dts-facts">
      <li>{{ p.dateLabel }}</li>
      <li>{{ p.readingTimeMinutes }} Min Read</li>
    </ul>
    <div class="dts-actions">
      <a class="codigrate-button" [routerLink]="p.url"><p>Read Post</p></a>
    </div>
  </div>

  <div class="dts-show">
    <!-- the post's cover, a way into the post -->
    <div class="bsx-stage">
      <ng-container *ngFor="let k of [ p.key ]">
        <a class="bsx-cover bsx-fade" [routerLink]="p.url" [attr.aria-label]="'Read: ' + p.title">
          <img [src]="p.cover" [alt]="p.title" decoding="async"/>
        </a>
      </ng-container>
    </div>

  </div>

<!-- every post under both columns (owner 2026-10-12, the home and the blog page alike): the title, each category with
     how many posts it has, then the posts as their round icons in one row that slides sideways; the shown one is
     ringed and the row follows it, a click brings a post up into the box (Read Post opens it) -->
  <div class="bsx-all">
    <div class="bsx-all-head">
      <h3 class="bsx-all-title">All Posts</h3>
      <ul class="bsx-all-cats">
        <li *ngFor="let c of categories"><span class="bsx-all-count">{{ c.count }}</span>{{ c.label }}</li>
      </ul>
    </div>
    <div class="bsx-deck" #deck role="group" aria-label="All posts">
      <a *ngFor="let q of posts; let i = index; trackBy: trackPost" class="bsx-thumb" [class.on]="i === index"
         [attr.aria-current]="i === index ? 'true' : null" [attr.href]="q.url" [title]="q.categoryLabel + ': ' + q.title"
         [attr.aria-label]="q.title" (click)="bringUp( i, $event )">
        <img [src]="q.icon || q.cover" alt="" width="44" height="44" loading="lazy" decoding="async" draggable="false"/>
      </a>
    </div>
  </div>
</section>
